import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import WhatsAppPage from './components/WhatsAppPage';
import EcommerceFlow from './components/EcommerceFlow';
import EcommerceAdmin from './components/EcommerceAdmin';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster position="top-right" />
        <Routes>
          <Route path="/ecommerce/admin" element={<EcommerceAdmin />} />
          <Route path="/ecommerce/*" element={<EcommerceFlow />} />
          <Route path="/*" element={<WhatsAppPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
